<template>
  <div v-if="gamesList && gamesList.length > 0">
    <!-- 🔶 KARTA 1: HLAVNÍ ORANŽOVÉ PROMO -->
    <div 
      @click="store.dispatch('loadOpenGameDetail', gamesList[0].GameID)"
      class="card border-0 p-4 rounded-4 mb-4 shadow position-relative overflow-hidden text-decoration-none" 
      :class="$store.state.isDarkMode ? 'game-promo-card-dark-orange' : 'game-promo-card-orange'"
    >
      <!-- Horní badge a ikona -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <span 
          class="badge rounded-pill px-3 py-1.5 fw-bold text-uppercase" 
          :style="$store.state.isDarkMode 
            ? 'font-size: 0.62rem; letter-spacing: 0.5px; background-color: rgba(255, 122, 0, 0.15); color: #FF7A00; border: 1px solid rgba(255, 122, 0, 0.25);' 
            : 'font-size: 0.62rem; letter-spacing: 0.5px; background-color: #FEE6C8; color: #C2460F; border: 1px solid #FEC88F;'"
        >
          <i class="bi bi-unlock-fill me-1"></i> Otevřená hra
        </span>
        <i class="bi bi-trophy-fill fs-3 opacity-20" :class="$store.state.isDarkMode ? 'text-warning' : 'style-dark-slate'"></i>
      </div>

      <!-- Název hry -->
      <h4 class="fw-black text-uppercase mb-1 tracking-tight" :class="$store.state.isDarkMode ? 'text-white' : 'style-promo-orange'" style="font-size: 1.1rem; line-height: 1.2;">
        {{ gamesList[0].GameName }}
      </h4>

      <!-- Termín konání akce -->
      <div v-if="gamesList[0].GameFrom" class="small mb-3 fw-bold" :class="$store.state.isDarkMode ? 'text-slate-400' : 'style-dark-slate'" style="font-size: 0.7rem;">
        <i class="bi bi-calendar-range me-1" :class="{'text-warning': $store.state.isDarkMode}"></i> 
        Běží od: {{ formatDateShort(gamesList[0].GameFrom) }} do {{ formatDateShort(gamesList[0].GameTo) }}
      </div>

      <!-- Popis hry -->
      <div
        v-if="renderedGameText0"
        class="small mb-4 game-text-clamp-3"
        :class="$store.state.isDarkMode ? 'text-slate-300' : 'style-muted-slate'"
        style="font-size: 0.78rem;"
        v-html="renderedGameText0"
      ></div>

      <!-- HLAVNÍ FINANČNÍ BLOK -->
      <div class="p-3 rounded-4 mb-3" :class="$store.state.isDarkMode ? 'container-dark-inner' : 'container-orange-inner'">
        <div class="row g-2 text-center">
          <div class="col-6 border-end" :class="$store.state.isDarkMode ? 'border-dark-subtle' : 'border-light-subtle'">
            <span class="d-block text-uppercase fw-bold" :class="$store.state.isDarkMode ? 'text-slate-400' : 'style-dark-slate'" style="font-size: 0.58rem;">Celkové výhry</span>
            <span class="fw-black d-block mt-1" :class="$store.state.isDarkMode ? 'text-warning' : 'style-promo-orange'" style="font-size: 1.3rem;">{{ formatDashIfWhole(gamesList[0].GameRewardVolume) }}</span>
          </div>
          <div class="col-6">
            <span class="d-block text-uppercase fw-bold" :class="$store.state.isDarkMode ? 'text-slate-400' : 'style-dark-slate'" style="font-size: 0.58rem;">Počet výherců</span>
            <span class="fw-black d-block mt-1" :class="$store.state.isDarkMode ? 'text-white' : 'style-dark-slate'" style="font-size: 1.3rem;">{{ gamesList[0].GameRewardCount }}x</span>
          </div>
        </div>
      </div>

      <!-- PARAMETRY HRY -->
      <div class="row g-2 text-center mb-4 mx-0 rounded-4 p-3 border" :class="$store.state.isDarkMode ? 'container-dark-inner' : 'container-orange-inner-border'">
        <div class="col-6 border-end px-1" :class="$store.state.isDarkMode ? 'border-dark-subtle' : 'border-light-subtle'">
          <span class="text-uppercase fw-bold d-block" :class="$store.state.isDarkMode ? 'text-slate-400' : 'style-dark-slate'" style="font-size: 0.56rem; letter-spacing: 0.5px;">Obchodní kapitál</span>
          <span class="fw-black mb-0 d-block mt-1" :class="$store.state.isDarkMode ? 'text-emerald-400' : 'style-dark-slate'" style="font-size: 1.1rem;">{{ formatTrimZeroCents(gamesList[0].GameCapital) }}</span>
        </div>
        <div class="col-6 px-1">
          <span class="text-uppercase fw-bold d-block" :class="$store.state.isDarkMode ? 'text-slate-400' : 'style-dark-slate'" style="font-size: 0.56rem; letter-spacing: 0.5px;">Vstupní vklad</span>
          <span class="fw-black mb-0 d-block mt-1" :class="$store.state.isDarkMode ? 'text-slate-200' : 'style-dark-slate'" style="font-size: 1.1rem;">{{ formatDashIfWhole(gamesList[0].GameCredit) }}</span>
        </div>
      </div>

      <!-- 📊 BARGRAF OBSAZENOSTI MÍST (OPRAVENÝ BEZ DUPLICIT) -->
      <div class="mb-4" v-if="parseInt(gamesList[0].GameTotalPlayer) > 0">
        <div class="d-flex justify-content-between align-items-center mb-2 fw-bold small" :class="$store.state.isDarkMode ? 'text-slate-300' : 'style-dark-slate'">
          <span>Obsazenost míst:</span>
          <span class="fw-black" :class="$store.state.isDarkMode ? 'text-white' : 'style-dark-slate'" style="font-size: 0.78rem;">
            {{ gamesList[0].GameRegisteredPlayer }} / {{ gamesList[0].GameTotalPlayer }} hráčů
          </span>
        </div>
        <div class="progress rounded-pill shadow-inner" :style="$store.state.isDarkMode ? 'height: 10px; background-color: #0F172A;' : 'height: 10px; background-color: rgba(0, 0, 0, 0.15);'">
          <div 
            class="progress-bar rounded-pill" 
            role="progressbar" 
            :style="{ 
              width: calculateProgress(gamesList[0].GameRegisteredPlayer, gamesList[0].GameTotalPlayer) + '%',
              background: $store.state.isDarkMode ? 'linear-gradient(90deg, #FF7A00 0%, #FF4D00 100%) !important' : 'linear-gradient(90deg, #F27524 0%, #D6490C 100%) !important'
            }"
          ></div>
        </div>
      </div>

      <!-- ODPOČET A TLAČÍTKO -->
      <div class="d-flex justify-content-between align-items-center mt-auto pt-3" :class="$store.state.isDarkMode ? 'border-dark-subtle-top' : 'border-light-subtle-top'">
        <div class="small fw-black" :class="$store.state.isDarkMode ? 'text-warning' : 'style-dark-slate'" v-if="gamesList[0].GameRegister">
          <i class="bi bi-clock-history me-1"></i> {{ getLiveCountdownText(gamesList[0].GameRegister) }}
        </div>
        <div v-else></div>
        
        <span
          v-if="isUserInGame(gamesList[0])"
          class="badge rounded-pill px-3 py-2 fw-bold text-uppercase"
          :class="$store.state.isDarkMode ? 'badge-joined-dark' : 'badge-joined-light'"
          style="font-size: 0.66rem;"
        >
          Jsi ve hře
        </span>
        <span 
          v-else-if="isRegisterActive(gamesList[0].GameRegister)"
          @click.stop="enterGame(gamesList[0])"
          class="badge text-white rounded-pill px-3 py-2 fw-bold text-uppercase shadow-sm hover-scale-btn" 
          :class="$store.state.isDarkMode ? 'btn-action-orange' : 'bg-dark'"
          style="font-size: 0.66rem; cursor: pointer;"
        >
          Vstoupit do hry
        </span>
        <span 
          v-else
          class="badge bg-secondary text-white rounded-pill px-3 py-2 fw-bold text-uppercase" 
          style="font-size: 0.66rem;"
        >
          Uzavřeno
        </span>
      </div>
    </div>
    <!-- 💎 KARTA 2: PRÉMIOVÁ KARTA (DYNAMICKY PŘELOGOVÁNA PODLE REŽIMU) -->
    <div 
      v-if="gamesList.length > 1"
      @click="store.dispatch('loadOpenGameDetail', gamesList[1].GameID)"
      class="card border-0 shadow-sm p-4 rounded-4 mb-4 position-relative overflow-hidden text-decoration-none"
      :class="$store.state.isDarkMode ? 'game-promo-card-dark-blue text-white' : 'game-promo-card-white text-dark'"
    >
      <div class="d-flex justify-content-between align-items-center mb-3">
        <span 
          class="badge rounded-pill px-2.5 py-1.5 fw-bold text-uppercase" 
          :style="$store.state.isDarkMode 
            ? 'background-color: rgba(30, 41, 59, 0.7); color: #94A3B8; font-size: 0.6rem; border: 1px solid #334155;' 
            : 'background-color: #F1F5F9; color: #475569; font-size: 0.6rem;'"
        >
          <i class="bi bi-people me-1"></i> Omezená kapacita
        </span>
        <span 
          class="badge rounded-pill px-3 py-1.5 fw-bold" 
          :style="$store.state.isDarkMode 
            ? 'background-color: rgba(16, 185, 129, 0.12) !important; color: #10B981; font-size: 0.64rem; border: 1px solid rgba(16, 185, 129, 0.2);' 
            : 'background-color: #E6F4EA !important; color: #2E7D32; font-size: 0.64rem;'"
        >
          Vklad: {{ formatDashIfWhole(gamesList[1].GameCredit) }}
        </span>
      </div>

      <h4 class="fw-black mb-1 text-uppercase" :class="$store.state.isDarkMode ? 'text-white' : 'text-dark'" style="font-size: 1.08rem; tracking-tight: -0.5px;">
        {{ gamesList[1].GameName }}
      </h4>

      <div v-if="gamesList[1].GameFrom" class="small mb-3 fw-medium" :class="$store.state.isDarkMode ? 'text-slate-400' : 'text-muted'" style="font-size: 0.7rem;">
        <i class="bi bi-calendar-range me-1 text-primary"></i> Běží od: {{ formatDateShort(gamesList[1].GameFrom) }} do {{ formatDateShort(gamesList[1].GameTo) }}
      </div>
        
      <div
        v-if="renderedGameText1"
        class="small mb-4 game-text-clamp-2"
        :class="$store.state.isDarkMode ? 'text-slate-300' : 'text-muted'"
        style="font-size: 0.76rem; line-height: 1.45;"
        v-html="renderedGameText1"
      ></div>

      <div class="row g-3 mb-4 p-3 rounded-4 mx-0 text-center" :class="$store.state.isDarkMode ? 'container-dark-inner' : 'bg-light border'">
        <div class="col-6 px-1 border-end" :class="$store.state.isDarkMode ? 'border-dark-subtle' : ''">
          <span class="text-uppercase d-block fw-bold" :class="$store.state.isDarkMode ? 'text-slate-400' : 'text-muted'" style="font-size: 0.55rem; letter-spacing: 0.5px;">Hlavní výhra</span>
          <span class="fw-extrabold mb-0 d-block mt-1" :class="$store.state.isDarkMode ? 'text-warning' : 'text-dark'" style="font-size: 1.1rem;">{{ formatDashIfWhole(gamesList[1].GameRewardVolume) }}</span>
        </div>
        <div class="col-6 ps-3 px-1">
          <span class="text-uppercase d-block fw-bold" :class="$store.state.isDarkMode ? 'text-slate-400' : 'text-muted'" style="font-size: 0.55rem; letter-spacing: 0.5px;">Obchodní kapitál</span>
          <span class="fw-extrabold mb-0 d-block mt-1" :class="$store.state.isDarkMode ? 'text-emerald-400' : 'text-dark'" style="font-size: 1.1rem;">{{ formatTrimZeroCents(gamesList[1].GameCapital) }}</span>
        </div>
      </div>

      <!-- 📊 BARGRAF PRO DRUHOU KARTU (OPRAVENÝ BEZ DUPLICIT) -->
      <div class="mb-4" v-if="parseInt(gamesList[1].GameTotalPlayer) > 0">
        <div class="d-flex justify-content-between align-items-center mb-2 fw-medium">
          <span :class="$store.state.isDarkMode ? 'text-slate-400' : 'text-muted'" style="font-size: 0.74rem;">Obsazenost míst:</span>
          <span 
            class="fw-bold px-2 py-0.5 rounded-pill border" 
            :style="$store.state.isDarkMode 
              ? 'font-size: 0.74rem; background-color: #1E293B; border-color: #334155 !important; color: #E2E8F0;' 
              : 'font-size: 0.74rem; background-color: #fff; color: #0F172A;'"
          >
            {{ gamesList[1].GameRegisteredPlayer }} / {{ gamesList[1].GameTotalPlayer }} hráčů
          </span>
        </div>
        <div class="progress rounded-pill shadow-inner" :style="$store.state.isDarkMode ? 'height: 10px; background-color: #0F172A; border: 1px solid #1E293B;' : 'height: 10px; background-color: #f1f5f9; border: 1px solid #E2E8F0;'">
          <div 
            class="progress-bar rounded-pill" 
            role="progressbar" 
            :style="{ 
              width: calculateProgress(gamesList[1].GameRegisteredPlayer, gamesList[1].GameTotalPlayer) + '%',
              background: 'linear-gradient(90deg, #3B82F6 0%, #1D4ED8 100%) !important'
            }"
          ></div>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center mt-3 pt-2 border-top" :class="$store.state.isDarkMode ? 'border-dark-subtle' : ''">
        <span class="small fw-bold" style="font-size: 0.7rem;" :class="$store.state.isDarkMode ? 'text-danger' : 'text-danger-light'" v-if="gamesList[1].GameRegister">
          <i class="bi bi-exclamation-circle me-1"></i>Konec {{ getLiveCountdownText(gamesList[1].GameRegister) }}
        </span>
        <div v-else></div>
        
        <span
          v-if="isUserInGame(gamesList[1])"
          class="badge rounded-pill px-3 py-2 fw-bold text-uppercase ms-auto"
          :class="$store.state.isDarkMode ? 'badge-joined-dark' : 'badge-joined-light'"
          style="font-size: 0.64rem;"
        >
          Jsi ve hře
        </span>
        <button 
          v-else-if="isRegisterActive(gamesList[1].GameRegister)"
          @click.stop="enterGame(gamesList[1])"
          class="btn btn-sm fw-bold rounded-pill px-4 text-uppercase ms-auto shadow-sm tracking-wide" 
          :class="$store.state.isDarkMode ? 'btn-action-blue' : 'btn-dark'"
          style="font-size: 0.64rem; border: none;"
        >
          Hrát
        </button>
        <span 
          v-else
          class="badge bg-secondary text-white rounded-pill px-3 py-2 fw-bold text-uppercase ms-auto" 
          style="font-size: 0.64rem;"
        >
          Uzavřeno
        </span>
      </div>
    </div>
  </div>
</template>




<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import dataService from "@/services/dataService.js";
import moment from "moment";

// Importujeme globální formátování a hotový vyskloňovaný odpočet
import { formatDateShort, getLiveCountdownText, isRegisterActiveGlobal } from "@/utils/DateFunctions.js";
import { formatTrimZeroCents, formatDashIfWhole } from "@/utils/NumberFormat";
import { formatRichText } from "@/helpers/richText";

const store = useStore();
const gamesList = ref([]);
const now = ref(moment());
let timerInterval = null;

const renderedGameText0 = computed(() => formatRichText(gamesList.value[0]?.GameText || ""));
const renderedGameText1 = computed(() => formatRichText(gamesList.value[1]?.GameText || ""));

// Specifická funkce sidebaru, která jen obalí globální vyskloňovaný text byznys popiskem
const getSidebarLabel = (dateStr) => {
  const countdownText = getLiveCountdownText(dateStr, now.value);
  if (countdownText === 'uzavřena') return 'Registrace uzavřena';
  return `Registrace končí ${countdownText}`;
};

const calculateProgress = (registered, total) => {
  if (!total || total == 0) return 0;
  return Math.min(Math.round((parseInt(registered) / parseInt(total)) * 100), 100);
};

const isUserInGame = (gameObj) => {
  const uid = store.getters.getUser?.UserID;
  if (!uid || !gameObj?.Player) return false;
  return gameObj.Player.some((player) => Number(player.UserID) === Number(uid));
};

const enterGame = (gameObj) => {
  if (!gameObj || isUserInGame(gameObj)) return;
  store.dispatch('addToGameHandler', {
    GameID: gameObj.GameID,
    GameName: gameObj.GameName,
    GameCredit: gameObj.GameCredit
  });
};

const isRegisterActive = (dateStr) => {
  return isRegisterActiveGlobal(dateStr, now.value);
};

const fetchGamesData = async () => {
  try {
    const response = await dataService.GetOpenGame();
    if (response) { gamesList.value = response; }
  } catch (error) {
    console.error(error);
  }
};

onMounted(() => {
  fetchGamesData();
  timerInterval = setInterval(() => {
    now.value = moment();
  }, 66666);
});

onUnmounted(() => {
  if (timerInterval) clearInterval(timerInterval);
});
</script>



<style scoped>
.fw-black { font-weight: 900; }
.fw-extrabold { font-weight: 800; }

.game-promo-card-orange,
.game-promo-card-white,
.game-promo-card-dark-orange,
.game-promo-card-dark-blue {
  border-radius: 1rem !important;
}

.container-orange-inner,
.container-orange-inner-border,
.container-dark-inner {
  border-radius: 0.85rem;
}

/* 🌓 SVĚTLÉ DOPLŇKOVÉ TŘÍDY */
.game-promo-card-orange {
  background: linear-gradient(135deg, #FFE8D6 0%, #FFD6BB 100%) !important;
  border: 1px solid #FEC88F !important;
  cursor: pointer;
  text-decoration: none !important;
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.game-promo-card-orange:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 24px rgba(234, 88, 12, 0.12) !important;
}
.game-promo-card-white {
  cursor: pointer;
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.2s ease;
  border: 1px solid #E2E8F0 !important;
}
.game-promo-card-white:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 30px rgba(15, 23, 42, 0.06) !important;
  border-color: #CBD5E1 !important;
}
.container-orange-inner { background: rgba(255, 255, 255, 0.58); border: 1px solid #FEC88F; }
.container-orange-inner-border { background: rgba(255, 255, 255, 0.45); border-color: #FEC88F !important; }
.border-light-subtle { border-color: #FEC88F !important; }
.border-light-subtle-top { border-top: 1px solid #FEC88F !important; }
.style-dark-slate { color: #172033 !important; }
.style-promo-orange { color: #C2460F !important; }
.style-muted-slate { color: #4B5A71 !important; }


/* 🌓 TMAVÉ BURZOVNÍ TŘÍDY */
.text-slate-200 { color: #E2E8F0 !important; }
.text-slate-300 { color: #CBD5E1 !important; }
.text-slate-400 { color: #94A3B8 !important; }
.text-emerald-400 { color: #34D399 !important; }

.container-dark-inner {
  background: #0F172A !important; 
  border: 1px solid #1E293B !important;
}
.border-dark-subtle { border-color: #1E293B !important; }
.border-dark-subtle-top { border-top: 1px solid #1E293B !important; }

.game-promo-card-dark-orange {
  background: #334155 !important;
  border: 1px solid #64748B !important;
  cursor: pointer;
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.game-promo-card-dark-orange:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 24px rgba(255, 77, 0, 0.12) !important;
  border-color: rgba(255, 138, 76, 0.55) !important;
}
.game-promo-card-dark-orange .container-dark-inner {
  background: #475569 !important;
  border: 1px solid #64748B !important;
}
.game-promo-card-dark-orange .border-dark-subtle {
  border-color: #64748B !important;
}
.badge-joined-light {
  background: rgba(5, 150, 105, 0.14);
  color: #059669;
}

.badge-joined-dark {
  background: rgba(52, 211, 153, 0.16);
  color: #34D399;
}

.btn-action-orange {
  background: linear-gradient(135deg, #FF7A00 0%, #FF4D00 100%) !important;
}

.game-promo-card-dark-blue {
  background: #111827 !important; 
  border: 1px solid #1F2937 !important;
  cursor: pointer;
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.game-promo-card-dark-blue:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 24px rgba(59, 130, 246, 0.1) !important;
  border-color: rgba(59, 130, 246, 0.4) !important;
}
.btn-action-blue {
  background: linear-gradient(135deg, #3B82F6 0%, #1D4ED8 100%) !important;
  color: white !important;
}

/* SPOLEČNÉ MECHANIKY */
.game-text-clamp-3 {
  display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical;
  overflow: hidden; line-height: 1.45;
}
.game-text-clamp-2 {
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;
  overflow: hidden; line-height: 1.45;
}
.game-text-clamp-3 :deep(p),
.game-text-clamp-2 :deep(p) {
  display: inline;
  margin: 0;
}
.shadow-inner { box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.4); }
.hover-scale-btn { transition: transform 0.15s ease; }
.card:hover .hover-scale-btn { transform: scale(1.04); }
</style>
